import { render, staticRenderFns } from "./LpPortfolioFundEdit.vue?vue&type=template&id=b4bb01ce"
import script from "./LpPortfolioFundEdit.vue?vue&type=script&lang=js"
export * from "./LpPortfolioFundEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports